// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend
/* eslint-disable*/
import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Optional,
  Output,
  Self,
  ViewChild
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControlName,
  NgControl
} from '@angular/forms';
import { UlItem } from '../../../models';
import { DayEntity } from '../calendar-single/models/calendar-single.interfaces';

@Component({
  selector: 'idp-molecule-calendar-dropdown',
  templateUrl: './calendar-dropdown.component.html',
  styleUrls: ['./calendar-dropdown.component.scss'],
  providers: [DatePipe]
})
export class CalendarDropdownComponent implements ControlValueAccessor {
  @ViewChild('textInput') textInput: ElementRef | undefined;
  @Input() addMargin = true;
  @Input() afterValueLabel = false;
  @Input() afterValueLabelText = '';
  @Input() anchorDate: string | undefined;
  @Input() arrowPosition = 'right';
  @Input() bottomLabelIcon = false;
  @Input() bottomLabelText = '';
  @Input() calendarModal: (DayEntity | null)[][] | undefined;
  @Input() disableFuture = false;
  @Input() disablePrevious = false;
  @Input() displayFlex = false;
  @Input() error = false;
  @Input() errorMessage = '';
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() helpIcon = false;
  @Input() id = 'placeholder';
  @Input() labelMargin = false;
  @Input() monthLabel = '';
  @Input() numbrOfPrevDays = 0;
  @Input() numbrOfFutureDays = 0;
  @Input() placeholderText = 'Placeholder Text';
  @Input() selectedDate = '';
  @Input() submitAttempt = false;
  @Input() topLabelIcon = false;
  @Input() topLabelText = '';
  @Input() yearLabel = '';
  @Input() changeDateFormat = '';
  @Input() hideClearButton = false;
  @Input() hideDoneButton = false;
  @Output() monthOffset: EventEmitter<number> = new EventEmitter<number>();
  @Output() value: EventEmitter<{
    id: string;
    value: string;
  } | null> = new EventEmitter<{ id: string; value: string } | null>();
  @Output() topLabelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() bottomLabelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() tooltipClicked: EventEmitter<any> = new EventEmitter();
  disabled: boolean | undefined;
  open = false;
  allowFocusChange = true;
  firstKeyDown = false;
  hasValue = false;
  dropdownWrapperFocused = false;
  calendarFocused = false;
  focused = false;
  monthOffsetValue = 0;
  private onChange:
    | ((item: null | { id: string; value: string }) => void)
    | undefined;
  private onTouched: (() => void) | undefined;

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public elementRef: ElementRef,
    public datepipe: DatePipe,
    @Optional() @Self() private ngControl: NgControl,
    @Optional() private controlName: FormControlName
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get errorState() {
    if (
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched &&
      this.submitAttempt &&
      Object.keys(this.errorMessages).length
    ) {
      this.errorMessage =
        this.errorMessages[Object.keys(this.ngControl.errors)[0]];
    }
    return (
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched &&
      this.submitAttempt
    );
  }

  /**
   * Sets date format
   * returns  the formatted date as per changeDateFormat value
   */
  setDateFormat() {
    return this.changeDateFormat
      ? this.datepipe.transform(this.selectedDate, this.changeDateFormat)
      : this.selectedDate;
  }

  setMonthOffSet(event: any) {
    this.monthOffsetValue = event;
    this.monthOffset.emit(this.monthOffsetValue);
  }

  toggle(event: any, passthrough = false) {
    if (this.disabled) {
      this.close();
      return;
    }

    if (!this.selectedDate) {
      this.monthOffsetValue = 0;
      this.monthOffset.emit(this.monthOffsetValue);
    }

    this.allowFocusChange = false;

    if (!passthrough) {
      event.preventDefault();
    }

    if (event.target.tagName === 'li') {
      this.open = false;
      return;
    } else {
      this.open = !this.open;
    }

    if (this.open) {
      setTimeout(() => {
        this.elementRef.nativeElement
          .querySelector('.calendar-container')
          .focus();
      });
    } else {
      setTimeout(() => {
        this.elementRef.nativeElement
          .querySelector('.idp-molecule-calendar-dropdown')
          .focus();
      });
    }

    this.allowFocusChange = true;
  }

  reFocus() {
    if (this.disabled) {
      return;
    }

    setTimeout(() => {
      this.elementRef.nativeElement
        .querySelector('.idp-molecule-calendar-dropdown')
        .focus();
    });
  }

  close() {
    this.open = false;
  }

  selected(event: any) {
    event.preventDefault();
    event.stopPropagation();
    event.target.parentElement.parentElement.parentElement
      .querySelector('div:first-child')
      .focus();

    this.firstKeyDown = false;
    this.hasValue = true;
  }

  setSelectedDate(dateString: string) {
    this.selectedDate = dateString;
    const updateValue: {
      id: string;
      value: string;
    } | null = dateString
      ? {
          id: this.id,
          value: dateString ? this.selectedDate : ''
        }
      : (null as {
          id: string;
          value: string;
        } | null);
    this.value.emit(updateValue);
    if (this.onChange) {
      this.onChange(updateValue);
    }

    if (dateString) {
      this.hasValue = true;
      if (this.afterValueLabel) {
        this.topLabelText = this.afterValueLabelText;
      }
    } else {
      this.hasValue = false;
      if (this.afterValueLabel) {
        this.topLabelText = '';
      }
    }

    if (this.afterValueLabel) {
      this.topLabelText = this.afterValueLabelText;
    }
  }

  setTopLabelTextAfterValue(): void {
    if (this.afterValueLabel) {
      this.topLabelText = this.afterValueLabelText;
    }
  }

  dropdownWrapperChangeFocused(focused: boolean) {
    if (this.allowFocusChange) {
      this.dropdownWrapperFocused = focused;
    }
  }

  calendarFocusChanges(focused: boolean) {
    if (this.allowFocusChange) {
      this.calendarFocused = focused;
    }
    this.changeDetectorRef.detectChanges();
  }

  checkFocused() {
    if (!this.calendarFocused && !this.dropdownWrapperFocused) {
      this.focused = false;
      this.close();
      if (this.onTouched) {
        this.onTouched();
      }
    } else {
      this.focused = true;
    }
    this.changeDetectorRef.detectChanges();
  }

  notify(level: any) {
    if (level === 'top') {
      this.topLabelClicked.emit(true);
    } else {
      this.bottomLabelClicked.emit(true);
    }
  }

  iconClicked() {
    this.tooltipClicked.emit(this.id);
  }

  writeValue(obj: UlItem) {
    const dateString = obj && obj.hasOwnProperty('value') ? obj.value : '';
    // @ts-ignore
    this.setSelectedDate(dateString);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: any) {
    this.disabled = isDisabled;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target) && this.open) {
      this.open = !this.open;
      if (!this.selectedDate) {
        this.monthOffsetValue = 0;
        this.monthOffset.emit(this.monthOffsetValue);
      }
    }
  }
}
